// removed by extract-text-webpack-plugin
module.exports = {"menu":"_1eDQEUlmT1kEj7mgBBGrSH","inner":"_3k-KWWAtjCIoVp1ZPc3giH","scrollToTop":"_1u1CDb5gBp6EYdDaXCbXy-","logo":"_1Wn9UbTD-dqRdnIZmLxWi1","logoFallbackText":"_2fr_fpPzhljvp6F-ubjPQT","logoImage":"_3IdTXrwfy0MfZfd_4ieVif","anchorsHeading":"_3BSVo-iNSMQ1tHQzEHxEkQ","listWrapper":"_1yX7aACIHnzRAdMtEVtNkf","list":"_2pbojlHopnoV0FDkaO__7J","header":"_2Os6cZAmvWJ5MuU51cp2TU","toggle":"YSfIOXuqxuLRS6ltE8irT","toggleText":"_2AMKMThv-Pb7PD4WYYhFn2","toggleCross":"_3RV9CiHGtbOEfojDDX_iSg","arrow":"_1Sr08WHEGaodxF41_5rrrk","button":"_1Lm84-8TS9cNSrYWpvNpUj","active":"_2R8F3q7bt69wUhkK47OF9Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AnchorMenu/AnchorMenu.module.scss
// module id = 731
// module chunks = 0